export function hasValidExtension(file, extensions) {
  if (!file?.name) return false;
  if (extensions === '*' || !extensions?.length) return true;

  const validExtensionsList = Array.isArray(extensions)
    ? extensions
    : extensions.split(',');

  const indexOfDot = file.name?.lastIndexOf('.');
  const fileExtension = file.name?.substring(indexOfDot).toLowerCase();
  return validExtensionsList.includes(fileExtension);
}
